import invariant from "tiny-invariant";
import { useBroadcastData } from "../BroadcastDataContext";
import type { TemplateType } from "./UpsertTemplateModal";
import { useCreateMarketingEmail } from "./hooks/useCreateMarketingEmail";
import { useUpdateMarketingEmail } from "./hooks/useUpdateMarketingEmail";

export const useUpsertTemplates = () => {
  const { data: broadcastData } = useBroadcastData();
  invariant(broadcastData, "Broadcast is required");

  const {
    id: broadcastId,
    marketing_email_template_id: existingTemplateId,
    marketing_email_template_name: templateName,
  } = broadcastData;
  const emailContent = broadcastData.broadcast_content?.email_content;

  const { mutateAsync: createTemplate } = useCreateMarketingEmail({
    broadcastId,
  });
  const { mutateAsync: updateTemplate } = useUpdateMarketingEmail({
    broadcastId,
  });

  const handleUpsert = ({
    name,
    templateType,
  }: {
    name: string;
    templateType: TemplateType;
  }) => {
    const content = emailContent ?? {
      body: [],
      sgids_to_object_map: {},
      inline_attachments: [],
    };

    if (existingTemplateId && templateType === "updateTemplate") {
      return updateTemplate({
        id: existingTemplateId,
        body: {
          name,
          content,
        },
      });
    }
    return createTemplate({
      body: {
        name,
        content,
      },
    });
  };

  return { handleUpsert, templateName };
};
